<script lang="ts">
  import { loadStripe } from "@stripe/stripe-js";
  import type { Stripe } from "@stripe/stripe-js";

  import { Router, Route } from "svelte-navigator";
  import Customer from "./Customer.svelte";

  import PaymentMethod from "./PaymentMethod.svelte";

  let stripe: Stripe = null;
  const secret_key = new URLSearchParams(window.location.search).get("sk");
  const pub_key = new URLSearchParams(window.location.search).get("pk");
  if (pub_key && secret_key) {
    loadStripe(pub_key).then((s) => (stripe = s));
  }

  const stripe_account = (() => {
    if (pub_key == "pk_live_5W8JlLyvm2Drii1LWXA7A8pS") {
      return "GMBH";
    } else if (pub_key == "pk_live_pc9Zcmaksn4Ak0ipJtUKhMul") {
      return "US";
    } else if (pub_key == "pk_live_F6FHJW8m1zCzIPQle24pMESY") {
      return "UK";
    } else {
      return "N/A";
    }
  })();
</script>

<div class="header">
  <img
    style="height: 100%"
    alt="orcam logo"
    src="https://www.orcam.com/wp-content/uploads/2021/11/logo_white-1.svg"
  />
</div>

<h1 style="text-align: center">
  Stripe Payment Method Editor -- Stripe Account: {stripe_account}
</h1>
{#if secret_key && pub_key && stripe}
  <Router>
    <Route path="/" primary={false} let:params>
      <Customer {secret_key} />
    </Route>
    <Route path="/add_method/:id" let:params primary={false}>
      <PaymentMethod {stripe} clientSecret={params.id} />
    </Route>
  </Router>
{:else if secret_key && pub_key}
  <h1>Loading...</h1>
{:else}
  <h1>Error: Please provide secret key and pub key</h1>
{/if}

<style>
  :global(body) {
    padding: 0;
    margin: 0;
  }
  .header {
    background-color: black;
    height: 30px;
    width: 100%;
    text-align: center;
    padding: 10px;
  }
</style>
